import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "flex items-center w-full"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "grow"
}, null, -1);
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'QueryOrder',
  props: {
    fields: null,
    field: null,
    order: null,
    onlySingleOrderMapping: null
  },
  emits: ['update:field', 'update:order', 'changed'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const onClick = field => {
      if (field === props.field) {
        emit('update:order', props.onlySingleOrderMapping[field] ?? (props.order === 'ASC' ? 'DESC' : 'ASC'));
        emit('changed');
        return;
      }
      emit('update:field', field);
      emit('update:order', props.onlySingleOrderMapping[field] ?? 'ASC');
      emit('changed');
    };
    const onReset = () => {
      emit('update:field', null);
      emit('update:order', null);
      emit('changed');
    };
    const dialog = ref(null);
    const show = () => dialog.value.show();
    const hide = () => dialog.value.hide();
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(RichDialog, {
        ref_key: "dialog",
        ref: dialog
      }, {
        action: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_NButton, {
          secondary: "",
          onClick: onReset
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('reset')), 1)]),
          _: 1
        }), _hoisted_3, _createVNode(_component_NButton, {
          secondary: "",
          type: "success",
          onClick: hide
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('close')), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(__props.fields), f => {
          return _openBlock(), _createElementBlock("div", {
            key: f,
            class: _normalizeClass(["flex-center cursor-pointer p-2 rounded bg-slate-50 mb-2 last:mb-0", {
              'font-bold': f === __props.field
            }]),
            onClick: $event => onClick(f)
          }, [f === __props.field ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            icon: __props.order === 'DESC' ? _ctx.IconEnum.AngleDown : _ctx.IconEnum.AngleUp,
            class: "mr-2"
          }, null, 8, ["icon"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.fields[f]), 1)], 10, _hoisted_1);
        }), 128))]),
        _: 1
      }, 512);
    };
  }
});